export const EVENT_ONCE: Readonly<AddEventListenerOptions> = Object.freeze({
  once: true,
  passive: true,
});
